// extracted by mini-css-extract-plugin
module.exports = {"news":"LatestNews_news__1cU9E","news_details__title":"LatestNews_news_details__title__1q0ON","news_details__desc":"LatestNews_news_details__desc__3lBv_"};